import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {DocumentFolder} from '../../models/folder/documentfolder';
import {DateItem} from '../../models/format/dateitem';
const apiUrl = `${environment.apiUrl}/api/format`;

@Injectable({
  providedIn: 'root'
})
export class FormatService {

  constructor(public  httpService: HttpClient) {
  }
  public getCurrentDate(): Observable<string>
  {
    return  this.httpService.get(`${apiUrl}/getcurrentdate`, { responseType: 'text'}).pipe(
      map(data => data.toString())
      );
  }
  public getCurrentDateVN(): Observable<string>
  {

    return  this.httpService.get(`${apiUrl}/getcurrentdatevn`, { responseType: 'text'}).pipe(
      map(data => data.toString())
    );
  }
  public getFirstLastCurrentByMonth(): Observable<DateItem>
  {
    return this.httpService.get(`${apiUrl}/getfirstlastcurrentbymonth`).pipe(
      map(data => new DateItem().deserialize(data)),
      catchError(() => throwError('items not found')));

  }
  public getCompareDate(date: String)
  {
    return this.httpService.get(`${apiUrl}/comparedate?date=${date}`).pipe(
      map(data => Number(data)),
      catchError(() => throwError('items not found')));

  }

}
